<!-- Info base de la persona que estima -->
 
<template>
  <div class="client-info-form grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    <div>
      <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" for="clientName">
        Nombre del cliente <span class="text-red-500 dark:text-red-400">*</span>
      </label>
      <input
        id="clientName"
        v-model="localClientName"
        type="text"
        placeholder="Ej. Acme Corp"
        class="form-control dark:bg-slate-700 dark:border-slate-600 dark:text-slate-100 dark:placeholder-slate-400"
        required
      />
    </div>
    <div>
      <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" for="ownerName">
        Quien arma la estimación <span class="text-red-500 dark:text-red-400">*</span>
      </label>
      <input
        id="ownerName"
        v-model="localOwnerName"
        type="text"
        placeholder="Ej. Juan Pérez"
        class="form-control dark:bg-slate-700 dark:border-slate-600 dark:text-slate-100 dark:placeholder-slate-400"
        required
      />
    </div>
    <div>
      <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" for="jiraTicket">JIRA Ticket</label>
      <input
        id="jiraTicket"
        v-model="localJiraTicket"
        type="text"
        placeholder="Ej. https://portinos.atlassian.net/browse/XX-XXXX"
        class="form-control dark:bg-slate-700 dark:border-slate-600 dark:text-slate-100 dark:placeholder-slate-400"
      />
      <p v-if="jiraTicketError" class="text-red-500 dark:text-red-400 text-xs mt-1">{{ jiraTicketError }}</p>
    </div>
    <div>
      <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" for="intranetUrl">Intranet URL</label>
      <input
        id="intranetUrl"
        v-model="localIntranetUrl"
        type="text"
        placeholder="Ej. https://intranet.portinos.com/index.php/main/ficha_request/XXXXX"
        class="form-control dark:bg-slate-700 dark:border-slate-600 dark:text-slate-100 dark:placeholder-slate-400"
        :class="{ 'border-red-500 focus:border-red-500 focus:ring-red-500': intranetUrlError }"
      />
      <p v-if="intranetUrlError" class="text-red-500 dark:text-red-400 text-xs mt-1">{{ intranetUrlError }}</p>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    initialClientName: {
      type: String,
      default: ""
    },
    initialOwnerName: {
      type: String,
      default: ""
    },
    initialJiraTicket: {
      type: String,
      default: ""
    },
    initialIntranetUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localClientName: this.initialClientName,
      localOwnerName: this.initialOwnerName,
      localJiraTicket: this.initialJiraTicket,
      localIntranetUrl: this.initialIntranetUrl,
      jiraTicketError: '',
      intranetUrlError: ''
    };
  },
  computed: {
    isValid() {
      return this.localClientName.trim() !== '' && 
             this.localOwnerName.trim() !== '' && 
             this.jiraTicketError === '' && 
             this.intranetUrlError === '';
    }
  },
  mounted() {
    // Emit initial validation state
    this.$emit("validation-change", this.isValid);
  },
  methods: {
    validateJiraTicket(ticket) {
      // Clear error if empty
      if (!ticket || ticket.trim() === '') {
        this.jiraTicketError = '';
        this.$emit('update-jira-ticket', '');
        return true;
      }
      
      const jiraPattern = /^https:\/\/portinos\.atlassian\.net\/browse\/[A-Z]+-\d+$/;
      const isValid = jiraPattern.test(ticket);
      
      if (!isValid) {
        this.jiraTicketError = 'El formato debe ser: https://portinos.atlassian.net/browse/XX-1234';
        return false;
      }
      
      this.jiraTicketError = '';
      this.$emit('update-jira-ticket', ticket);
      return true;
    },
    validateIntranetUrl(url) {
      if (!url) {
        this.intranetUrlError = '';
        this.$emit('update-intranet-url', '');
        return true;
      }
      
      const intranetPattern = /^https:\/\/intranet\.portinos\.com\/index\.php\/main\/ficha_request\/\d+$/;
      const isValid = intranetPattern.test(url);
      
      if (!isValid) {
        this.intranetUrlError = 'El formato debe ser: https://intranet.portinos.com/index.php/main/ficha_request/XXXXX';
        this.$emit('update-intranet-url', '');
        return false;
      }
      
      this.intranetUrlError = '';
      this.$emit('update-intranet-url', url);
      return true;
    }
  },
  watch: {
    localClientName(newVal) {
      this.$emit("update-client-name", newVal);
      this.$nextTick(() => {
        this.$emit("validation-change", this.isValid);
      });
    },
    localOwnerName(newVal) {
      this.$emit("update-owner-name", newVal);
      this.$nextTick(() => {
        this.$emit("validation-change", this.isValid);
      });
    },
    localJiraTicket(newVal) {
      this.validateJiraTicket(newVal);
      this.$nextTick(() => {
        this.$emit("validation-change", this.isValid);
      });
    },
    localIntranetUrl(newVal) {
      this.validateIntranetUrl(newVal);
      this.$nextTick(() => {
        this.$emit("validation-change", this.isValid);
      });
    },
    // Watch for prop changes to update local data
    initialClientName(newVal) {
      this.localClientName = newVal;
    },
    initialOwnerName(newVal) {
      this.localOwnerName = newVal;
    },
    initialJiraTicket(newVal) {
      this.localJiraTicket = newVal;
    },
    initialIntranetUrl(newVal) {
      this.localIntranetUrl = newVal;
    }
  }
};
</script>